import React from "react";
import PropTypes from "prop-types";
import { UiAddListTable, UiAddListTableItem, UiAddListTableHeader, UiAddListTableRow, UiAddListTableBody } from "./AddListTable.style";
/**
 * 可增加列表的Table
 */

const AddListTable = ({
  children
}) => {
  return /*#__PURE__*/React.createElement(UiAddListTable, null, /*#__PURE__*/React.createElement("div", {
    className: "modalContentList"
  }, /*#__PURE__*/React.createElement("div", {
    className: "modalTable"
  }, children)));
};

export default AddListTable;
AddListTable.propTypes = {
  children: PropTypes.any
};
export const AddListTableRow = ({
  children,
  isadmin
}) => /*#__PURE__*/React.createElement(UiAddListTableRow, {
  isadmin: isadmin
}, children);
AddListTableRow.propTypes = {
  children: PropTypes.any,
  isadmin: PropTypes.bool
};
export const AddListTableHeader = ({
  children
}) => /*#__PURE__*/React.createElement(UiAddListTableHeader, null, children);
AddListTableHeader.propTypes = {
  children: PropTypes.any
};
export const AddListTableBody = ({
  children
}) => /*#__PURE__*/React.createElement(UiAddListTableBody, null, children);
AddListTableBody.propTypes = {
  children: PropTypes.any
};
export const AddListTableItem = ({
  children,
  flex
}) => /*#__PURE__*/React.createElement(UiAddListTableItem, {
  flex: flex
}, children);
AddListTableItem.propTypes = {
  children: PropTypes.any,
  flex: PropTypes.number
};